import Loading from "../../common/loading";
import BarChart from "../../common/charts/BarChart";
import { categorizeAgeData } from "../../../utils/Functions";

const ProfileAgeChart = ({ birthyearStats, isLoadingBirthyearStats }: any) => {
  return (
    <div className="w-full">
      {isLoadingBirthyearStats ? (
        <Loading />
      ) : (
        birthyearStats?.length > 0 && (
          <BarChart
            categories={Object.keys(categorizeAgeData(birthyearStats))?.map(
              (item: any) => item
            )}
            data={Object.values(categorizeAgeData(birthyearStats))?.map(
              (item: any) => item
            )}
            name="تعداد کاربران"
            xaxisTitle="سن کاربران"
            background="#29ABE2"
          />
        )
      )}
    </div>
  );
};

export default ProfileAgeChart;
